import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Field, NumInput } from "@/components/join/Field";
import { PhotoPicker } from "@/components/join/PhotoPicker";
import { Success } from "@/components/join/Success";

const STATS = ["power", "participation", "attacks", "defenses", "repairs", "heals"];
const EMPTY = Object.fromEntries(STATS.map((k) => [k, ""]));

export const StatsForm = ({ players }) => {
  const [playerId, setPlayerId] = useState("");
  const [stats, setStats] = useState(EMPTY);
  const [note, setNote] = useState("");
  const [images, setImages] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await api.post("/public/stats", { playerId, ...stats, note, images });
      setDone(true); setStats(EMPTY); setNote(""); setImages([]);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  if (done) return <Success testid="stats-success" title="Stats sent" text="A leader will check them and update the roster." onAgain={() => setDone(false)} />;
  return (
    <form onSubmit={submit} data-testid="stats-form">
      <div style={{ marginBottom: 16 }}>
        <Field label="Your name on the roster *">
          <select className="lg-select" value={playerId} onChange={(e) => setPlayerId(e.target.value)} required data-testid="stats-player-select">
            <option value="">Choose your name…</option>
            {players.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </Field>
      </div>
      <div className="lg-grid" style={{ marginBottom: 16 }}>
        {STATS.map((k) => (
          <Field key={k} label={k[0].toUpperCase() + k.slice(1)}>
            <NumInput value={stats[k]} onChange={(v) => setStats((s) => ({ ...s, [k]: v }))} testid={`stats-${k}`} />
          </Field>
        ))}
      </div>
      <div style={{ display: "grid", gap: 16, marginBottom: 18 }}>
        <Field label="Note (optional)"><textarea className="lg-textarea" value={note} onChange={(e) => setNote(e.target.value)} maxLength={400} data-testid="stats-note" /></Field>
        <Field label="Screenshots (optional)" hint="Your ranking or profile screen, up to 4."><PhotoPicker value={images} onChange={setImages} testid="stats-photos" /></Field>
      </div>
      {error && <p className="lg-err" style={{ marginBottom: 14 }} data-testid="stats-error">{error}</p>}
      <button className="lg-btn" disabled={busy || !playerId} data-testid="stats-submit">{busy ? "Sending…" : "Send my stats"}</button>
    </form>
  );
};
